// Shared color tokens and style objects for the CEDS Strategy Council Portal.
// Import C for color values, S for reusable style objects.
// Never hardcode hex strings inline — use C.navy, C.gold, etc.

export const C = {
  navy:      '#122326',
  navyMid:   '#1e3a3f',
  gold:      '#C9A84C',
  goldLight: '#f0dfa0',
  cream:     '#F8F5EE',
  white:     '#FFFFFF',
  muted:     '#5a6670',
  rule:      '#d4c9b0',
  accent:    '#2e6b72',
  red:       '#c0392b',
  green:     '#27ae60',
  blue:      '#2980b9',
};

export const S = {
  card: {
    background: '#FFFFFF',
    border: '1px solid #d4c9b0',
    borderRadius: 4,
    padding: '20px 24px',
    marginBottom: 16,
  },
  btn: {
    primary: {
      background: '#122326',
      color: '#FFFFFF',
      border: 'none',
      borderRadius: 4,
      padding: '9px 20px',
      fontSize: 14,
      fontWeight: 600,
      cursor: 'pointer',
    },
    secondary: {
      background: 'transparent',
      color: '#122326',
      border: '1.5px solid #122326',
      borderRadius: 4,
      padding: '8px 20px',
      fontSize: 14,
      fontWeight: 600,
      cursor: 'pointer',
    },
    gold: {
      background: '#C9A84C',
      color: '#122326',
      border: 'none',
      borderRadius: 4,
      padding: '9px 20px',
      fontSize: 14,
      fontWeight: 700,
      cursor: 'pointer',
    },
  },
  input: {
    width: '100%',
    padding: '9px 12px',
    border: '1px solid #d4c9b0',
    borderRadius: 4,
    fontSize: 14,
    fontFamily: 'inherit',
    boxSizing: 'border-box',
  },
  label: {
    display: 'block',
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: '#122326',
    marginBottom: 5,
  },
};
